import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";
import { ControlContainer, FormGroupDirective } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationDialogComponent } from "@dialogs/confirmation/confirmation.component";

import { CommonService } from "@services/common.service";
import { CanvasService } from "@services/canvas.service";

import { CHARTS } from "../../../models/charts";
import { OBJECTS } from "../../../models/objects";
import { environment } from "@environments/environment";
@Component({
    selector: "app-visualizations",
    templateUrl: "./visualizations.component.html",
    styleUrls: ["./visualizations.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class VisualizationsComponent implements OnInit, OnChanges {
  chartList = CHARTS;
  objectList = OBJECTS;

  constructor(
    public commonService: CommonService,
    public dialog: MatDialog,
    private canvasService: CanvasService,
    public parentF: FormGroupDirective
  ) {}
  @Output() chartTypeChanged: EventEmitter<string> = new EventEmitter();
  @Output() chartTypeAdded: EventEmitter<string> = new EventEmitter();
  @Output() chartDataChange = new EventEmitter<any>();
  @Input() charts!: any;
  @Input() selectedChartType!: any;
  @Input() canvasOptions!: any;
  childForm: any;
  public tooltip = "";
  public tooltipExisting =
    "Click and drag icon into canvas to search for an existing chart";

  switchChartDialog(type: any) {
    if (this.charts.length <= 0) return;

    if (
      type.details.toLowerCase() !=
      this.childForm.controls["chartType"].value.toLowerCase()
    ) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        disableClose: true,
        data: {
          message: "Change this chart type?",
          actionButton: "CHANGE",
        },
        panelClass: "canvas-dialog",
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.changeChartType(type);
        }
      });
    }
  }

  switchChart(name: string) {
    this.chartTypeChanged.emit(name);
    setTimeout(function () {
      let icons = document.querySelectorAll(".chart_img");
      for (let i = 0; i < icons.length; i++) {
        icons[i].classList.remove("selected");
      }
      const element = document.querySelector("#" + name);
      if (element) {
        element.classList.add("selected");
      }
    }, 100);
  }

  changeChartType(type: string) {
    const previousType = this.childForm.get("chartType")!.value;
    const parsedType = JSON.parse(JSON.stringify(type));
    this.childForm.get("chartType")!.setValue(type);
    let seriesdata: any;
    const datapoints = this.childForm.get("dataPointIds")!.value;
    if (
      (previousType == "Table" || previousType == "List") &&
      parsedType.details != "Table" &&
      parsedType.details != "List"
    ) {
      if (datapoints && datapoints.length > 0) {
        seriesdata = {
          dataPointId: datapoints[0],
          breakDownDataPointId: null,
        };

        this.childForm.get("appliedSeries")!.setValue([seriesdata]);
        this.childForm.get("groupDateRange")!.setValue("M");

        this.childForm.get("colorType")!.setValue("manual");

        const groupAggregate: any = [];
        const data = {
          dataPointId: datapoints[0],
          modifiers: [
            { id: this.canvasOptions.groupOptions.data[0].id, value: "" },
          ],
        };
        groupAggregate.push(data);

        this.childForm.get("groupdata").setValue(groupAggregate);

        this.childForm.get("dynamicChartColors").setValue([]);
      }
    } else {
      switch (parsedType.details) {
        case "Table":
        case "List":
          this.childForm.get("visibleDataPointIds")!.setValue(datapoints);
          if (previousType != "Table" && previousType != "List") {
            this.childForm.get("dynamicChartColors").setValue([]);
            this.childForm.get("manualChartColors").setValue([]);
          }
          this.childForm.get("colorType").setValue("dynamic");
          break;
        case "Pie":
          seriesdata = {
            dataPointId: datapoints[0],
            breakDownDataPointId: null,
          };
          this.childForm.get("visibleDataPointIds")!.setValue([seriesdata]);
          this.childForm.get("colorType").setValue("manual");
          break;
      }
    }

    // make refresh call and emit the chart data to the paren
    this.canvasService.refreshCanvas(this.childForm).subscribe(
      (success: any) => {
        this.canvasService.triggerEnable();
        const data = success.data;
        this.canvasService.pushChartToStorage(data);
        if (!data.colorType) {
          let colorType = "manual";
          if (data.chartType == "Table" || data.chartType == "List")
            colorType = "dynamic";
          data.colorType = colorType;
        }
        this.chartDataChange.emit(data);
        this.switchChart(data.chartType);
      },
      (error: any) => {
        this.canvasService.triggerEnable();
        const data = this.canvasService.getChartFromStorage();
        if (!data.colorType) {
          let colorType = "manual";
          if (data.chartType == "Table" || data.chartType == "List")
            colorType = "dynamic";
          data.colorType = colorType;
        }
        this.chartDataChange.emit(data);
        this.switchChart(data.chartType);
      }
    );
  }

  addChart(event: any) {
    this.chartTypeAdded.emit(event);
  }
  ngOnChanges(): void {
    if (this.selectedChartType) this.switchChart(this.selectedChartType);
    if (this.charts.length <= 0) {
      this.tooltip = "Drag icon into canvas to create a new chart";
      setTimeout(function () {
        let icons = document.querySelectorAll(".chart_img");
        for (let i = 0; i < icons.length; i++) {
          icons[i].classList.remove("selected");
        }
      }, 100);
    } else {
      this.tooltip =
        "Click icon to switch chart types or click and drag icon into canvas to create a new chart";
    }
  }

  ngOnInit(): void {
    this.childForm = this.parentF.form;
    if (this.charts && this.charts.length <= 0) {
      this.tooltip = "Drag icon into canvas to create a new chart";
    } else {
      this.tooltip =
        "Click icon to switch chart types or click and drag icon into canvas to create a new chart";
    }
  }
}
